import {BaseContainerModel} from '../base-container.model';
import {
  bl_prt_printable_format_image_link_RowInterface, bl_prt_printable_format_image_link_RowClass
} from '../../dbschema/index';

export class PrintableFormatImageLinkContainerModel extends BaseContainerModel {
  bl_prt_printable_format_image_link: bl_prt_printable_format_image_link_RowInterface = new bl_prt_printable_format_image_link_RowClass();
}
